<template>
  <div>
    <SpCardContent title="基本信息">
      <div class="common-border">
        <el-form
          ref="sopFom"
          :model="sopFom"
          :rules="sopRules"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="规则名称："
            prop="rule_name"
          >
            <el-input
              v-model="sopFom.rule_name"
              placeholder="请输入名称"
              size="small"
            />
          </el-form-item>
          <el-form-item label="是否开启：">
            <el-switch
              v-model="sopFom.is_active"
              active-text="开启"
              size="small"
            />
          </el-form-item>
        </el-form>
      </div>
    </SpCardContent>

    <SpCardContent>
      <template v-slot:header>
        <div class="header">
          推送周期设置
          <span class="subtitle">点击新增时间，可设置多条时间任务，设置后请绑定导购任务</span>
        </div>
      </template>

      <div class="common-border">
        <el-form
          ref="sopFom"
          :model="sopFom"
          :rules="sopRules"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item
            label="推送时间："
            prop="send_time"
          >
            <el-button
              type="primary"
              size="small"
              @click="setTuisongTime"
            >
              新增时间
            </el-button>
          </el-form-item>
        </el-form>
      </div>

      <template v-if="send_content.length > 0">
        <div
          v-for="(item, index) in send_content"
          :key="index"
          class="plane-box"
        >
          <ul class="plane-box-list">
            <li>
              <h4 class="title">
                <template v-if="item.status === '1'">
                  群添加规则后，{{ item.hour }}小时{{ item.min }}分后提醒执行
                </template>
                <template v-else-if="item.status === '2'">
                  群添加规则后，{{ item.days }}天后 当日{{ item.time }}分后提醒执行
                </template>
              </h4>
              <template>
                <div class="content">
                  <div
                    v-if="item.task_id"
                    class="content__info"
                  >
                    <p>任务名称：{{ item.task_title }}</p>
                    <p class="target_box">
                      <span>
                        任务目标:
                        <span
                          v-for="k in item.subtask_list"
                          :key="k"
                        > {{ k }}， </span>
                      </span>

                      <el-link
                        type="primary"
                        @click="selectTask(index)"
                      >
                        重新选择
                      </el-link>
                    </p>
                  </div>
                  <div
                    v-if="!item.task_id"
                    class="content__info"
                  >
                    <span>*</span>选择任务：
                    <el-button
                      type="primary"
                      size="small"
                      @click="selectTask(index)"
                    >
                      请选择任务
                    </el-button>
                  </div>
                  <div class="content__delete">
                    <span
                      class="icon iconfont icon-shanchu"
                      @click="handleDelete(index)"
                    />
                  </div>
                </div>
              </template>
            </li>
          </ul>
        </div>
      </template>
    </SpCardContent>
    <div class="fotter-toolbar">
      <el-button
        type="primary"
        @click="submitForm"
      >
        保存
      </el-button>
    </div>

    <!-- 选择 -->
    <TaskSelect
      :task-visible="taskVisible"
      :select-data="selectStoreData"
      :type="4"
      @closeTaskDialog="closeTaskDialog"
      @chooseTask="chooseTask"
    />

    <!-- 设置推送时间 -->
    <el-dialog
      title="推送时间设置"
      :visible.sync="timeVisible"
      width="40%"
    >
      <div>
        <div>
          <el-radio
            v-model="syncParmas.status"
            label="1"
          >
            加入规则后<el-input
              v-model="syncParmas.hour"
              size="small"
              style="width: 100px"
            />
            小时
            <el-input
              v-model.number="syncParmas.min"
              size="small"
              style="width: 100px"
            />分钟后提醒发送
          </el-radio>
        </div>
        <div style="margin-top: 20px">
          <el-radio
            v-model="syncParmas.status"
            label="2"
          >
            加入规则后<el-input
              v-model.number="syncParmas.days"
              size="small"
              style="width: 100px"
            />
            天后 当日
            <el-time-select
              v-model="syncParmas.time"
              :picker-options="{
                start: '00:00',
                step: '00:05',
                end: '24:00'
              }"
              size="small"
              style="width: 100px"
              placeholder="选择时间"
            />提醒发送
          </el-radio>
        </div>
      </div>
      <span
        slot="footer"
        class="dialog-footer"
      >
        <el-button @click="timeVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="setTimeRules"
        >确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getSopDetail, createSop, updateSop } from '@/api/membership/membershipsop'
import TaskSelect from '@/components/taskSelect'

export default {
  components: {
    TaskSelect
  },
  data () {
    const sopRules = {
      rule_name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
      send_time: [{ required: true, message: '请设置时间' }],
      send_content: [{ required: true, message: '请设置时间' }]
    }
    return {
      sopFom: {
        rule_name: '', //规则名称
        is_active: true, //是否启用 1开启 0关闭
        send_content: [] //推送内容设置
      },
      syncParmas: {
        status: '1',
        days: '',
        time: '',
        hour: '',
        min: '',
        task_id: '',
        task_title: ''
      },
      sopRules,
      taskVisible: false,
      selectStoreData: {},
      taskList: [],
      selectIndex: -1,
      taskIds: [],
      timeVisible: false,
      send_content: [] //推送内容设置
    }
  },
  mounted () {
    //const sop_id = this.$route.query.id
    const { id } = this.$route.params
    if (id) {
      this.getSopDetail(id)
    }
  },
  methods: {
    //获取sop详情
    getSopDetail (sopId) {
      getSopDetail(sopId).then((res) => {
        if (res) {
          console.log('res', res)
          this.sopFom.rule_name = res.rule_name
          this.sopFom.is_active = res.is_active === 1 ? true : false
          this.sopFom.send_content = res.send_content
          this.send_content = res.send_content
        } else {
          return this.$message.error('获取详情失败')
        }
      })
    },
    selectTask (index) {
      this.taskVisible = true
      this.selectIndex = index
    },
    // 关闭门店对话框
    closeTaskDialog () {
      this.taskVisible = false
    },
    //选择任务数据
    chooseTask (selectdata) {
      const send_content = this.send_content
      send_content[this.selectIndex].task_id = selectdata.task_id
      send_content[this.selectIndex].task_title = selectdata.task_title
      send_content[this.selectIndex].subtask_list = selectdata.subtask_list
      this.taskVisible = false
    },

    //移除任务
    handleDelete (index) {
      this.$confirm('确定删除该规则吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.send_content.splice(index, 1)
          this.$message({
            type: 'success',
            message: '删除成功!'
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    },
    setTuisongTime () {
      this.syncParmas = {
        status: '1',
        days: '',
        time: '',
        hour: '',
        min: '',
        task_id: '',
        task_title: ''
      }
      this.timeVisible = true
    },
    //设置时间周期任务
    setTimeRules () {
      if (this.syncParmas.status === '0') {
        return this.$message.error('请选择推送时间周期')
      }
      if (this.syncParmas.status === '1') {
        if (this.syncParmas.hour === '') {
          return this.$message.error('推送时间周期必填')
        }
        if (this.syncParmas.min === '') {
          return this.$message.error('推送时间周期必填')
        }
      } else {
        if (this.syncParmas.days === '') {
          return this.$message.error('推送时间周期必填')
        }
        if (this.syncParmas.time === '') {
          return this.$message.error('推送时间周期必填')
        }
      }
      const { status, days, time, hour, min } = this.syncParmas
      let send_content = {
        status,
        days,
        time,
        hour,
        min
      }
      this.send_content.push(send_content)
      this.timeVisible = false
    },
    //保存数据
    async submitForm () {
      this.loading = true
      let isComplete = true
      if (this.send_content.length === 0) {
        return this.$message.error('请设置推送周期设置')
      }
      this.send_content.map((item) => {
        if (!item.task_id || item.task_id === '') {
          isComplete = false
          return isComplete
        }
      })
      if (!isComplete) {
        return this.$message.error('请选择任务')
      }
      this.sopFom.send_content = this.send_content
      this.sopFom.send_content = JSON.stringify(this.sopFom.send_content)
      this.sopFom.is_active = this.sopFom.is_active === true ? '1' : '0'
      if (this.$route.params.id) {
        this.update(this.$route.params.id, this.sopFom)
      } else {
        this.create(this.sopFom)
      }
    },
    //创建
    create (form) {
      createSop(form).then((res) => {
        if (res) {
          this.loading = false
          this.$message({
            type: 'success',
            message: '保存成功'
          })
          this.$router.go(-1)
        } else {
          this.$message({
            type: 'error',
            message: '保存失败'
          })
        }
      })
    },
    //更新
    update (id, form) {
      updateSop(id, form).then((res) => {
        if (res) {
          this.$message({
            type: 'success',
            message: '修改成功'
          })
          this.$router.go(-1)
        } else {
          this.$message({
            type: 'error',
            message: '修改失败'
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-main {
  background: #dddddd;
}
.el-form {
  padding: 8px 0;
}
.el-form-item {
  margin-bottom: 5px;
}
.el-form-item__label {
  color: #999999;
}
.subtitle {
  font-size: 12px;
  color: #666666;
  font-weight: normal;
}

//border: 1px solid #f1f1f1;
//box-sizing: border-box;
.header {
  padding: 0 0 20px 5px;
  //border-bottom: 1px solid #dddddd;
  font-size: 14px;
  color: #111111;
  font-weight: 600;
}
.tongji-body {
  //border:1px solid $primary_active;
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px;
  background: #f1f9ff;
  margin: 20px;

  &__item {
    flex: 1;
    text-align: center;
  }
}

.plane-box {
  padding: 20px;
  .title {
    font-size: 14px;
    color: #333333;
    font-weight: bold;
  }
  .plane-box-list {
    li {
      margin-top: 20px;
      .content {
        margin-top: 10px;
        display: flex;
        justify-content: flex-start;
        align-items: center;
        &__info {
          flex: 1;
          background: #f1f1f1;
          padding: 20px;
          border-radius: 5px;
          line-height: 24px;
          .target_box {
            display: flex;
            justify-content: space-between;
            align-items: center;
            width: 100%;
          }
        }
        &__delete {
          flex: 1;
          padding-left: 20px;
          margin-top: 25px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
